
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1ONYq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $153139ad147638d7$var$_jquery = $153139ad147638d7$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $153139ad147638d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $153139ad147638d7$var$_init = module.exports.init = function init() {
    var attempts = 0;
    /*--------------------------------------------------------------------------------------------------------------------------------------*/ /*  Fragen und Antworten per Ajax im Klapper -------------------------------------------------------------------------------------------*/ /*--------------------------------------------------------------------------------------------------------------------------------------*/ var loading = {
        init: function init(settings) {
            loading.config = {
                anchors: (0, $153139ad147638d7$var$_jquery["default"])(".accordion-grid-container.ajax-loading .card-title a"),
                target: ".ajax-content",
                root: "#ajax-elements"
            };
            $153139ad147638d7$var$_jquery["default"].extend(loading.config, settings);
            loading.setup();
            // let $this = $($(".accordion-grid-container .card-body")[0]);
            // $(".accordion-grid-container .card-title a:first").addClass("already-loaded");
            // $(".accordion-grid-container .card:first").addClass("active");
            // loading.url = $(".accordion-grid-container .card-title a:first").data("href");
            // loading.getContent($this, function () {
            //   $this.find(loading.config.target).show("hide");
            //   $(".accordion-grid-container .card-body").addClass("active");
            //   $(".accordion-grid-container .card:first .collapse").addClass("show");
            // });
            setTimeout(function() {
                var $first = (0, $153139ad147638d7$var$_jquery["default"])(".accordion-grid-container .card-title a:first");
                $first.trigger("click");
                $first.attr("aria-expanded", "true");
                $first.parents(".card").find(".collapse").addClass("show");
            }, 500);
        },
        setup: function setup() {
            loading.config.anchors.click(function(e) {
                if (!(0, $153139ad147638d7$var$_jquery["default"])(this).hasClass("already-loaded")) {
                    e.preventDefault();
                    (0, $153139ad147638d7$var$_jquery["default"])(this).addClass("already-loaded");
                    loading.url = (0, $153139ad147638d7$var$_jquery["default"])(this).data("href");
                    loading.manageStyles((0, $153139ad147638d7$var$_jquery["default"])(this));
                }
            });
        },
        manageStyles: function manageStyles($this) {
            (0, $153139ad147638d7$var$_jquery["default"])(".accordion-grid-container .card").removeClass("active");
            (0, $153139ad147638d7$var$_jquery["default"])(".accordion-grid-container .card .collapse").removeClass("show");
            loading.getContent($this.parents(".card"), function() {
                $this.find(loading.config.target).show();
            });
        },
        getContent: function getContent($this, callback) {
            $this.find(loading.config.target).load(loading.url + " " + loading.config.root + " > *", callback);
        }
    };
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") loading.init();
        else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=gridAccordion.module.49d88d94.js.map
